import { Link } from 'react-router-dom';
import { Sprout, Sun, Coins, ArrowRight } from 'lucide-react';
import './landing.css';

/**
 * Concept 2 — ALMANAC.
 * Warm, editorial, retail-investor friendly. Cream paper background,
 * Fraunces serif headlines, three-act story ("Plant / Tend / Harvest").
 * Says "this is for the wife's roth target, the 10-year goal, the
 * grandkids' fund."
 */
export default function Landing2() {
  return (
    <div className="lp2 lp-shell" data-testid="landing-2">
      {/* LandingSwitcher removed Round 91l. */}

      {/* Botanical SVG curl behind hero */}
      <svg className="botanical" width="380" height="380" style={{ top: 60, right: -40 }} viewBox="0 0 200 200" fill="none">
        <path d="M100 20 Q 60 100 100 180 Q 140 100 100 20" stroke="currentColor" strokeWidth="1.5" />
        <path d="M40 100 Q 100 70 160 100 Q 100 130 40 100" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="100" cy="100" r="60" stroke="currentColor" strokeWidth="0.8" fill="none" />
        <circle cx="100" cy="100" r="35" stroke="currentColor" strokeWidth="0.8" fill="none" />
      </svg>

      <div className="max-w-5xl mx-auto px-6 py-24 relative">
        <div className="text-xs uppercase tracking-[0.4em] text-amber-700 mb-6 body-text font-bold">
          The Dividend Almanac · Est. 2025
        </div>

        <h1 className="lead" data-testid="lp2-title">
          Where your dividends <em>grow up.</em>
        </h1>

        <p className="mt-8 max-w-2xl text-lg body-text leading-relaxed text-stone-700">
          DiviDrip is the calm, careful tracker for income investors who play the long game.
          Exchange-verified pay dates. DRIP projections that match Excel.
          A dividend calendar you can <span className="accent font-bold">trust</span>.
        </p>

        <div className="mt-10 flex flex-wrap gap-3 body-text">
          <Link to="/" className="lp-btn lp-btn-primary-2" data-testid="lp2-cta-primary">
            Begin tracking <ArrowRight className="w-4 h-4" />
          </Link>
          <a href="/glossary" className="lp-btn border border-stone-400 text-stone-700">
            How it works
          </a>
        </div>

        {/* Three-act story */}
        <div className="mt-32 grid md:grid-cols-3 gap-6">
          <div className="act-card">
            <Sprout className="w-7 h-7 text-emerald-700 mb-3" />
            <div className="text-xs uppercase tracking-[0.2em] text-stone-500 body-text font-bold">Act One</div>
            <h3 className="text-3xl mt-2 mb-3" style={{ fontFamily: 'Fraunces, serif' }}>Plant.</h3>
            <p className="body-text text-stone-600 leading-relaxed text-sm">
              Build a watchlist. Compare dividend kings against high-yield rookies. Pin the face-offs that matter to you so they're one click away forever.
            </p>
          </div>
          <div className="act-card">
            <Sun className="w-7 h-7 text-amber-700 mb-3" />
            <div className="text-xs uppercase tracking-[0.2em] text-stone-500 body-text font-bold">Act Two</div>
            <h3 className="text-3xl mt-2 mb-3" style={{ fontFamily: 'Fraunces, serif' }}>Tend.</h3>
            <p className="body-text text-stone-600 leading-relaxed text-sm">
              Track every lot. Log every DRIP. See the dividend calendar populated with exchange-verified dates — not guesses. Get notified when a holding raises or cuts.
            </p>
          </div>
          <div className="act-card">
            <Coins className="w-7 h-7 text-amber-800 mb-3" />
            <div className="text-xs uppercase tracking-[0.2em] text-stone-500 body-text font-bold">Act Three</div>
            <h3 className="text-3xl mt-2 mb-3" style={{ fontFamily: 'Fraunces, serif' }}>Harvest.</h3>
            <p className="body-text text-stone-600 leading-relaxed text-sm">
              Watch your portfolio compound. Project income out 10, 20, 30 years with the DRIP simulator. Share a beautiful triangle card when you want to brag.
            </p>
          </div>
        </div>

        <div className="mt-24 max-w-3xl">
          <div className="quote body-text">
            &ldquo;I built DiviDrip because every other tracker either got dividend dates wrong, or wanted $20/month to tell me what my spreadsheet already knew. This one tells me the truth, for free.&rdquo;
          </div>
          <div className="mt-3 text-sm text-stone-500 body-text">— A dividend investor who got tired of being lied to</div>
        </div>

        <div className="mt-32 pt-8 border-t border-stone-300 body-text text-xs text-stone-500 flex items-center justify-between flex-wrap gap-3">
          <span>© 2026 DiviDrip · Made with care, indexed by Massive.</span>
          <span><a href="/privacy-policy" className="underline">Privacy</a> · <a href="/glossary">Glossary</a></span>
        </div>
      </div>
    </div>
  );
}
